import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import i18next from 'i18next'
import Joi from 'joi'
import { Country, TechSetupFailureReason } from '../../../../constants'
import { AppointmentRescheduleFormData } from '../../../../types'
import { getPrimaryRescheduleReasons, getPrimaryRescheduleReasonDisplayText, PrimaryAppointmentRescheduleReason } from '../utils'

const string = Joi.string()
const nullableString = string.allow(null, '')

function validationSchema(
  country: Country,
  deliveryModel: DeliveryModel | undefined,
  isPooledSchedulingOn: boolean | undefined
): Joi.ObjectSchema<AppointmentRescheduleFormData> {
  const validReasons = getPrimaryRescheduleReasons(country, deliveryModel, isPooledSchedulingOn)
  const reason = Joi.string().valid(...validReasons)

  if (country === Country.DE) {
    return Joi.object<AppointmentRescheduleFormData>({
      description: nullableString.optional(),
      reason: reason.required().messages({ 'any.only': i18next.t('common.required') }),
      techSetupFailReason: nullableString.optional(),
    }).required()
  }

  const displayText = getPrimaryRescheduleReasonDisplayText(country, deliveryModel)
  const techSetupFailReason = Joi.string().valid(...Object.values(TechSetupFailureReason))

  const otherDisplayText = displayText[PrimaryAppointmentRescheduleReason.OTHER]

  const description = Joi.any().when('reason', {
    is: PrimaryAppointmentRescheduleReason.OTHER,
    then: string.required().messages({
      'string.empty': i18next.t(`pages.appointment.reschedule.reason.requiredDescription.message`, { reason: otherDisplayText }),
    }),
    otherwise: nullableString.optional(),
  })

  const techSetupFailReasonConditional = (validReasons as readonly string[]).includes(PrimaryAppointmentRescheduleReason.TECH_SETUP_FAILED)
    ? Joi.any().when('reason', {
        is: PrimaryAppointmentRescheduleReason.TECH_SETUP_FAILED,
        then: techSetupFailReason.required().messages({
          'string.empty': i18next.t(`pages.appointment.reschedule.reason.requiredDescription.message`, {
            reason: displayText[PrimaryAppointmentRescheduleReason.TECH_SETUP_FAILED],
          }),
          'any.only': i18next.t('common.required'),
        }),
        otherwise: nullableString.optional(),
      })
    : nullableString.optional()

  return Joi.object<AppointmentRescheduleFormData>({
    description,
    reason: reason.required().messages({ 'any.only': i18next.t('common.required') }),
    techSetupFailReason: techSetupFailReasonConditional,
  }).required()
}

export { validationSchema }
